import { css } from '@emotion/react'

export const root = css`
  position: relative;
`
